import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../appReducer';
import { BusinessSessionStateI } from '../business/session/sessionSlice';

const useSessionData = (): {
  isAdmin: boolean;
  canSeeVisitors: boolean;
  canSeeEmployees: boolean;
  canEditEmployees: boolean;
  canEditBilling: boolean;
} => {
  const currentSession = useSelector(
    (state: RootState) => state.session
  ) as BusinessSessionStateI;
  const currentWorkspace = currentSession.workspaces.current;

  const permissionsFlags = useMemo(() => {
    const isAdmin = !!currentWorkspace?.is_admin;
    const permissions = currentWorkspace?.permissions || [];

    return {
      isAdmin,
      canSeeVisitors: isAdmin || permissions.includes('get_visitors'),
      canSeeEmployees: isAdmin || permissions.includes('employee_list'),
      canEditEmployees:
        isAdmin || permissions.includes('add_edit_remove_employees'),
      canEditBilling: isAdmin || permissions.includes('billing_settings'),
    };
  }, [currentWorkspace]);

  return permissionsFlags;
};

export default useSessionData;
